/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2022
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import InProgressBannerContent from "./InProgressBannerContent";

function LaneRepriceProgressState({ message }) {
  return <InProgressBannerContent message={message} />;
}

export default LaneRepriceProgressState;
